var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddVariableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-511 -14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,18a3,3,0,0,1-3-3V7A3,3,0,0,1,7,4,1,1,0,0,0,7,2,5,5,0,0,0,2,7v8a5,5,0,0,0,5,5,1,1,0,0,0,0-2ZM18,7v6a1,1,0,0,0,2,0V7a5,5,0,0,0-5-5,1,1,0,0,0,0,2,3,3,0,0,1,3,3Zm3,11H20V17a1,1,0,0,0-2,0v1H17a1,1,0,0,0,0,2h1v1a1,1,0,0,0,2,0V20h1a1,1,0,0,0,0-2Z",
    transform: "translate(509 12)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(516 29)",
    fill: "#434db8",
    fontSize: 13,
    fontFamily: "Nunito-ExtraBold, Nunito",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVariableIcon);
export default __webpack_public_path__ + "static/media/add-variable-icon.57d007ce39bf9b2d1bf92b60a038dddb.svg";
export { ForwardRef as ReactComponent };